export default {"src":"/_next/static/media/icon_search2.b010821f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};